import React from "react";
// import { EmailInput } from "../../ui/EmailInput";
import { PhoneInput } from "../../ui/PhoneInput";
import * as S from "./styles";
// import { DecorativeDot } from "../../../lib/styles";
import { HOMEPAGE_ANCHOR_CONTAINER_IDs } from "../../../lib/constants";

export function CTASection() {
  return (
    <S.StyledSection id={HOMEPAGE_ANCHOR_CONTAINER_IDs.cta.key}>
      <S.FirstSectionWrapper>
        <S.ContentBox>
          <S.Heading>
            The Future of Campaigning Is Here.{" "}
            <S.HeadingSpan>
              Are You Ready?
              {/* <DecorativeDot
                src="/images/icons/dot-grey.svg"
                alt="Decorative dot"
              /> */}
            </S.HeadingSpan>
          </S.Heading>

          <S.SeparatorContainer>
            <S.SeparatorDot />
            <S.SeparatorLine />
            <S.SeparatorDot />
          </S.SeparatorContainer>

          <S.WaitlistBox>
            <S.WaitlistHeader>
              <S.WaitlistIcon src="/images/logos/logo192.png" alt="Logo" />
              <S.WaitlistText>
                <S.TextHighlight>Hello, I'm Reach!</S.TextHighlight>
                Can I help you with your campaign?
              </S.WaitlistText>
            </S.WaitlistHeader>
            <S.EmailInputWrapper>
              {/* <EmailInput variant="secondary" /> */}
              <PhoneInput variant="secondary" />
            </S.EmailInputWrapper>
          </S.WaitlistBox>
        </S.ContentBox>
      </S.FirstSectionWrapper>
    </S.StyledSection>
  );
}
